module.exports = __webpack_public_path__ + "static/img/comunidadoCorteServiciosAGETIC.dac78c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comunidadoCorteServiciosAGETIC.jpg
// module id = hLDi
// module chunks = 9